function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { map } from 'ramda';
import { setSearchType } from '../../../reducers/actions/search.actions';
import { SEARCH_DROPDOWN_CONSTANTS } from '../search.constants';
import { SearchTypeSelector, SearchTypeTabsSelector } from '../../../reducers/selectors/search.selectors';
import CustomerCareLocaleKeys from '../../../locales/keys';
var SearchTypeTabsController = /*#__PURE__*/function () {
  function SearchTypeTabsController($ngRedux) {
    _classCallCheck(this, SearchTypeTabsController);
    this.$ngRedux = $ngRedux;
    this.customerCareLocaleKeys = CustomerCareLocaleKeys;
    this.syncTabData = this.syncTabData.bind(this);
    this.tabSelected = this.tabSelected.bind(this);
    this.evaluateTabState = this.evaluateTabState.bind(this);
  }
  return _createClass(SearchTypeTabsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        setSearchType: setSearchType
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          searchType: SearchTypeSelector(store),
          tabData: SearchTypeTabsSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.searchType) {
        this.actions.setSearchType(SEARCH_DROPDOWN_CONSTANTS.INDIVIDUAL);
      }
      this.syncTabData();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(selectedTab) {
      if (selectedTab.id !== this.state.searchType) {
        this.actions.setSearchType(selectedTab.id);
        this.syncTabData();
        this.searchTabChanged()(selectedTab);
      }
    }
  }, {
    key: "evaluateTabState",
    value: function evaluateTabState(tab) {
      tab.active = this.state.searchType === tab.id;
    }
  }, {
    key: "syncTabData",
    value: function syncTabData() {
      map(this.evaluateTabState, this.state.tabData);
    }
  }]);
}();
export default {
  template: require('./search.type.tabs.html'),
  controller: SearchTypeTabsController,
  bindings: {
    searchTabChanged: '&'
  }
};